import { zodResolver } from "@hookform/resolvers/zod";
import {
  type FieldValues,
  type Resolver,
  type UseFormProps,
  type UseFormReturn,
  useForm,
} from "react-hook-form";
import type { z } from "zod";

export type ZodFormValues<TSchema extends z.ZodType> = z.output<TSchema> &
  FieldValues;

export function zodFormConfig<TSchema extends z.ZodType>(
  schema: TSchema,
  options?: Omit<UseFormProps<ZodFormValues<TSchema>>, "resolver">,
): UseFormProps<ZodFormValues<TSchema>> {
  return {
    ...options,
    // Generic ZodType is not a FieldValues schema to the resolver overloads.
    resolver: zodResolver(schema as never) as Resolver<ZodFormValues<TSchema>>,
  };
}

export function useZodForm<TSchema extends z.ZodType>(
  schema: TSchema,
  options?: Omit<UseFormProps<ZodFormValues<TSchema>>, "resolver">,
): UseFormReturn<ZodFormValues<TSchema>> {
  return useForm(zodFormConfig(schema, options));
}
